import 'babel-polyfill';

import 'dotdotdot';

import Slick from 'slick-carousel';

import Vue from 'vue';
// import VueAnalytics from 'vue-analytics';
import VueGtm from 'vue-gtm';
import VueMeta from 'vue-meta';
// import VuePlyr from 'vue-plyr';
import VueRouter from 'vue-router';
// import VueYouTubeEmbed from 'vue-youtube-embed';

/*Vue.use(VueAnalytics, {
    id : ' UA-93260698-12',
});*/
// Vue.use(VueGtm, {
//      id : 'GTM-5HFMLPJ',
//      enabled : true,
//      debug : true,
//      ignoredViews : [],
//  });

Vue.use(VueMeta);
// Vue.use(VuePlyr);
Vue.use(VueRouter);
// Vue.use(VueYouTubeEmbed);

import App from './App.vue';
import Article from './components/Article.vue';
import ErrorNotFound from './components/ErrorNotFound.vue';
import Glossary from './components/Glossary.vue';
import Home from './components/Home.vue';
import SearchResults from './components/SearchResults.vue';
import Topic from './components/Topic.vue';
import Category from './components/Category.vue';
import Infomaterialien from './components/Infomaterialien.vue';

import cssMediaQueryHelper from './services/cssMediaQueryHelper';

cssMediaQueryHelper.mediaQueries = [
    function(watch){
        watch.factor = 1;
        if (window.matchMedia('(max-width: 767px)').matches) {
            console.log(767);
            watch.isPhone = true;
        } else {
            console.log(960);
            watch.isPhone = false;
        }
    },
    function(watch){
        if (window.matchMedia('(min-width: 1200px)').matches) {
            console.log(1200);
            watch.factor = 1.25;
        }
    },
    function(watch){
        if (window.matchMedia('(min-width: 1440px)').matches) {
            console.log(1440);
            watch.factor = 1.5;
        }
    },
    function(watch){
        if (window.matchMedia('(min-width: 1920px)').matches) {
            console.log(1920);
            watch.factor = 2;
        }
    },
    function(watch){
        if (window.matchMedia('(min-width: 2400px)').matches) {
            console.log(2400);
            watch.factor = 2.5;
        }
    },
];
cssMediaQueryHelper.watch = {
    factor : 1,
    isPhone : false,
};
cssMediaQueryHelper.addListener();

const routes = [
    {
        path : '/',
        component : Home,
    },
    {
        path : '/404',
        component : ErrorNotFound,
    },
    {
        path : '/glossar',
        component : Glossary,
        name : 'glossary',
    },
    {
        path : '/infomaterialien',
        component : Infomaterialien,
        name : 'infomaterialien',
    },
    {
        path : '/suche/:term',
        component : SearchResults,
        name : 'search',
    },
    {
        path : '/thema/:tag',
        component : Topic,
    },
    {
        path : '/:permalink',
        component : Article,
    },
    /*{
        path : '/category/:category',
        component : Category,
    },*/
    {
        path : '/:parentcategory/:category',
        component : Category,
    },    // {
    //     path : '*', redirect : '/404',
    // },
];

import wpApi from './services/wpApi';

wpApi.baseUrl = process.env.WP_BASE_URL;
wpApi.host = window.location.protocol + "//" + window.location.host;//process.env.WP_HOST;

import storage from './services/storage';

storage.cache.menus = {};
storage.cache.options = {};
storage.cache.tags = {
    'primary_keyword' : [],
    'series_keyword' : [],
    'sequencing_keyword' : [],
};
storage.events = new Vue();
storage.promises = {};
storage.states.glossaryIsShown = false;
storage.states.menuIsActive = false;
storage.states.popupAccordionData = null;
storage.states.popupAccordionId = null;
storage.states.popupExternalLinkHref = null;
storage.states.previousSearchValue = '';
storage.states.searchResultsAreShown = false;
storage.states.searchResultsReferrer = null;
storage.states.searchValue = '';
storage.states.viewIsScrolled = false;

const router = new VueRouter({
    mode : 'history',
    routes,
});

// Global navigation guard to add trailing slash
router.beforeEach((to, from, next) => {
    if (to.path !== '/' && !to.path.endsWith('/')) {
        const path = `${to.path}/`; // Add trailing slash
        next({ path, query: to.query, hash: to.hash });
    } else {
        next();
    }
});

const app = new Vue({
    router,
    data : {
        cache : storage.cache,
        events : storage.events,
        promises : storage.promises,
        states : storage.states,
    },
    el : '#app',
    render : h=>h(App),
});



//////////////////
// WEBPACK FOOTER
// ./public/js/script.js
// module id = 261
// module chunks = 0